import * as React from "react";
import type { SVGProps } from "react";
const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M6.94 20.25H3.76v-3.18L16.77 4.06l3.18 3.18zM15.02 6.56l2.63 2.63"
    />
  </svg>
);
export default SvgEdit;
